import { Icon } from "./Icon";
import { cx } from "@/lib/cx";

interface PinIndicatorProps {
  /** Mostra o texto "fixada" junto do icone (nao depende so do simbolo). */
  withText?: boolean;
  className?: string;
  /** Mantido por compatibilidade; a cor agora vem do contexto. */
  muted?: boolean;
}

/**
 * Indicador de conversa fixada (RF-UX-123): icone SVG decorativo
 * (`aria-hidden`) + nome acessivel em texto. Nunca usa `aria-label` num
 * elemento sem papel, que o axe acusa como `aria-prohibited-attr`.
 * A cor segue o token `--chatlist-pinned-color` do Telegram via `.pin-glyph`.
 * O SVG substitui o antigo glifo "⚲" (U+26B2), que virava tofu em varias
 * fontes/plataformas.
 */
export function PinIndicator({ withText, className }: PinIndicatorProps) {
  return (
    <span className={cx("pin-glyph", className)} title="Fixada">
      <Icon name="pin" size={15} />
      {withText ? (
        <span className="ml-1 text-[11px] font-semibold">fixada</span>
      ) : (
        <span className="sr-only">Conversa fixada</span>
      )}
    </span>
  );
}
